import {Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {ReferralPaymentGrid} from "./grid";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import {PaginateContext} from "../../../context/paginate";
import {getReferralPaymentReport} from "../../../services/report/referral_payment";

export function ReferralPaymentReportManagement() {

  const [referralPaymentReport, setReferralPayment] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);

  // const [personId, setPersonId] = useState(null);
  // const [agentId, setAgentId] = useState(null);
  // const [fieldId, setFieldId] = useState(null);
  // const [branchId, setBranchId] = useState(null);
  // const [createdAtFrom, setCreatedAtFrom] = useState("");
  // const [createdAtTo, setCreatedAtTo] = useState("");
  // const [paidAtFrom, setPaidAtFrom] = useState("");
  // const [paidAtTo, setPaidAtTo] = useState("");

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getReferralPaymentReport(paginate);
    if (result.status === 200) {
      const {referral_payment_report, total_count} = result.data;
      setReferralPayment(referral_payment_report || []);
      setGridTotalRowCount(total_count);
    }
  }

  // const filter = () => {
  //   const data = {}
  //   if (personId) {
  //     data.person_id = personId;
  //   }
  //
  //   if (agentId) {
  //     data.agent_id = agentId;
  //   }
  //
  //   if (fieldId) {
  //     data.field_id = fieldId;
  //   }
  //
  //   if (branchId) {
  //     data.branch_id = branchId;
  //   }
  //
  //   if (createdAtFrom) {
  //     data.created_at_from = createdAtFrom;
  //   }
  //
  //   if (createdAtTo) {
  //     data.created_at_to = createdAtTo;
  //   }
  //
  //   if (paidAtFrom) {
  //     data.paid_at_from = paidAtFrom;
  //   }
  //
  //   if (paidAtTo) {
  //     data.paid_at_to = paidAtTo;
  //   }
  //
  //   return data
  // };

  useEffect(() => {
    // const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="w-full">
        <Card className="pt-8 w-full">
          <CardHeader floated={true} shadow={false} className="rounded-none w-full">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">گزارش پرداخت معرف</Typography>
            </div>

          </CardHeader>
          <CardBody className="w-full">

            <div className="w-full overflow-x-scroll">
              <ReferralPaymentGrid
                referralPaymentReport={referralPaymentReport}
              />
            </div>
          </CardBody>

          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  )
    ;
}